import { createAsyncThunk } from '@reduxjs/toolkit';
import selectApiBaseUrl from '../../env/selectors/selectApiBaseUrl';
import { selectTrayUserToken } from '../selectors';
import client from '../../../services/api-client';
import trackMixPanelEvent from '../../../helpers/trackMixPanelEvent';

export default createAsyncThunk('connectionManager/deleteTraySolutionInstance', async (payload, { getState }) => {
  const { solutionInstanceId, instanceTitle, eventName = 'Remove integration' } = payload;
  const state = getState();

  const apiBaseUrl = selectApiBaseUrl(state);
  const trayUserToken = selectTrayUserToken(state);

  const url = `${apiBaseUrl}/workflows/delete-solution-instance/${trayUserToken}`;
  await client(url, { body: { solutionInstanceId }, method: 'DELETE' });

  trackMixPanelEvent(eventName, { 'Integration Title': instanceTitle });

  return { solutionInstanceId };
});
